import Api from '@/utils/api'

export default {
	priority: 10,
	run: (options) => {
		let baseUrl = `${options.window?.location?.origin || ''}${process.env.VUE_APP_SHOP_API_BASE_URL}`
		options.apis.shopApi = new Api({ baseUrl })
	},
}

